import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHockeyappComponent } from './simple-icons-hockeyapp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHockeyappComponent ],
    exports:      [ SimpleIconsHockeyappComponent ],
    bootstrap:    []
})
export class SimpleIconsHockeyappModule {}
